import React, { useState } from "react";
import logo from "../../assets/logo.png";
import styles from "./Login.module.css";
import Auth from "../../utils/api/Auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function ResetPassword() {
  const [input, setInput] = useState({
    token: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [toggle, setToggle] = useState(false);

  const navigate = useNavigate();

  const email = useSelector((state) => state.userData.resetEmail);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };
  const submitLoginHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const resetPasswordRes = await Auth.resertPassword({
        token: input.token,
        password: input.password,
        email,
      });
      toast.success(resetPasswordRes.data.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
      setIsLoading(false);
      navigate("/login");
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  const passwordToggleHandler = () => {
    setToggle((toggle) => !toggle);
  };

  return (
    <div className={styles.main}>
      <ToastContainer />
      <div className={styles.main_header}></div>

      <div className={styles.main_content}>
        <div className={styles.main_content_logo}>
          <img src={logo} alt="logo" />
        </div>
        <div className={styles.main_content_inner}>
          <p>Reset Password</p>
        </div>
        <form
          onSubmit={submitLoginHandler}
          className={styles.main_content_inner_form}
        >
          <input
            type="number"
            placeholder="Enter code"
            name="token"
            required
            value={input.token}
            onChange={handleInputChange}
            className={styles.input_field}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
            className={styles.password_input_field}
          >
            <input
              type={toggle ? "name" : "password"}
              placeholder="Password"
              name="password"
              required
              value={input.password}
              onChange={handleInputChange}
            />
            <div onClick={passwordToggleHandler}>
              {toggle && (
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="16" height="16" rx="4" fill="#FAFAFA" />
                  <path
                    d="M1.33337 6.6665C1.33337 6.6665 3.66671 9.33317 8.00004 9.33317C12.3334 9.33317 14.6667 6.6665 14.6667 6.6665M2.66671 7.76317L1.33337 9.33317M14.6667 9.33317L13.336 7.76517M5.94271 9.11984L5.33337 10.9998M10.042 9.12517L10.6667 10.9998"
                    stroke="#3C3E3F"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
              {!toggle && (
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="16" height="16" rx="4" fill="#FAFAFA" />
                  <path
                    d="M14.1714 7.30816C14.4874 7.7215 14.4874 8.2795 14.1714 8.69216C13.1761 9.9915 10.7881 12.6668 8.00009 12.6668C5.21209 12.6668 2.82409 9.9915 1.82876 8.69216C1.67501 8.49425 1.59155 8.25078 1.59155 8.00016C1.59155 7.74955 1.67501 7.50607 1.82876 7.30816C2.82409 6.00883 5.21209 3.3335 8.00009 3.3335C10.7881 3.3335 13.1761 6.00883 14.1714 7.30816V7.30816Z"
                    stroke="#3C3E3F"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                    stroke="#3C3E3F"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>
          </div>

          <button
            type="submit"
            className={styles.login_button}
            disabled={isLoading}
            style={{
              cursor: isLoading ? "not-allowed" : "default",
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            {isLoading ? `Loading...` : `Reset Password`}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
